import React, { Component } from 'react';
import { Button, MenuItem } from 'core/components';
import { inject, observer } from 'mobx-react';
import ClearAlertDialog from './ClearAlertDialog';

@inject('$alerting')
@observer
export default class ClearAlertButton extends Component {
  state = {
    clearRequestPending: false,
    showDialog: false
  };

  static defaultProps = {
    fill: true,
    disabled: false
  };

  componentDidMount() {
    this._mounted = true;
  }

  componentWillUnmount() {
    this._mounted = false;
  }

  get alertModels() {
    const { models } = this.props;
    return Array.isArray(models) ? models : [models];
  }

  get buttonText() {
    return `Clear ${this.alertModels.length > 1 ? `${this.alertModels.length} Alerts` : 'Alert...'}`;
  }

  handleClearAlerts = (formValues) => {
    const { $comments, $alerting } = this.props;
    const { comment } = formValues || {};

    this.setState({ clearRequestPending: true, showDialog: false });

    $alerting
      .clearAlarms(this.alertModels, { comment, toast: true })
      .then(() => {
        if (this._mounted) {
          this.setState({
            clearRequestPending: false
          });
        }

        // We create the comment in node, so force fetch to show new model
        $comments.collection.fetch({ force: true });
      })
      .catch(() => {
        if (this._mounted) {
          this.setState({
            clearRequestPending: false
          });
        }
      });
  };

  openClearDialog = () => this.setState({ showDialog: true });

  closeClearDialog = () => this.setState({ showDialog: false });

  render() {
    const { showDialog, clearRequestPending } = this.state;
    const { asMenuItem, fill, disabled, buttonProps: propButtonProps } = this.props;
    const ButtonComponent = asMenuItem ? MenuItem : Button;
    const disableButton = disabled || clearRequestPending || this.alertModels.length === 0;
    const buttonProps = {
      icon: 'tick',
      disabled: disableButton,
      text: this.buttonText,
      fill,
      textAlign: 'left',
      onClick: this.openClearDialog,
      ...propButtonProps
    };

    return (
      <>
        <ButtonComponent {...buttonProps} />
        <ClearAlertDialog
          isOpen={!!showDialog}
          alertModels={this.alertModels}
          onClose={this.closeClearDialog}
          onSubmit={this.handleClearAlerts}
        />
      </>
    );
  }
}
